import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { clearCacheWhere } from '@/utils/cacheKeyRegistry';

// Import translation files by namespace
import commonEN from './locales/en/common.json';
import commonZH from './locales/zh/common.json';

import vendorsEN from './locales/en/vendors.json';
import vendorsZH from './locales/zh/vendors.json';

import categoriesEN from './locales/en/categories.json';
import categoriesZH from './locales/zh/categories.json';

import contactsEN from './locales/en/contacts.json';
import contactsZH from './locales/zh/contacts.json';

import customersEN from './locales/en/customers.json';
import customersZH from './locales/zh/customers.json';

import productsEN from './locales/en/products.json';
import productsZH from './locales/zh/products.json';

import ordersEN from './locales/en/orders.json';
import ordersZH from './locales/zh/orders.json';

import financeEN from './locales/en/finance.json';
import financeZH from './locales/zh/finance.json';

import occEN from './locales/en/occ.json';
import occZH from './locales/zh/occ.json';

import procurementEN from './locales/en/procurement.json';
import procurementZH from './locales/zh/procurement.json';

import shippingEN from './locales/en/shipping.json';
import shippingZH from './locales/zh/shipping.json';

import claimsEN from './locales/en/claims.json';
import claimsZH from './locales/zh/claims.json';

import governanceEN from './locales/en/governance.json';
import governanceZH from './locales/zh/governance.json';

import pricingEN from './locales/en/pricing.json';
import pricingZH from './locales/zh/pricing.json';

import reportsEN from './locales/en/reports.json';
import reportsZH from './locales/zh/reports.json';

import taxonomyEN from './locales/en/taxonomy.json';
import taxonomyZH from './locales/zh/taxonomy.json';

import scnEN from './locales/en/scn.json';
import scnZH from './locales/zh/scn.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    // Use namespaces like digitalops-ui
    defaultNS: 'common',
    ns: [
      'common',
      'vendors',
      'categories',
      'contacts',
      'customers',
      'products',
      'orders',
      'procurement',
      'finance',
      'occ',
      'shipping',
      'claims',
      'governance',
      'pricing',
      'reports',
      'taxonomy',
      'scn',
    ],
    resources: {
      en: {
        common: commonEN,
        vendors: vendorsEN,
        categories: categoriesEN,
        contacts: contactsEN,
        customers: customersEN,
        products: productsEN,
        orders: ordersEN,
        procurement: procurementEN,
        finance: financeEN,
        occ: occEN,
        shipping: shippingEN,
        claims: claimsEN,
        governance: governanceEN,
        pricing: pricingEN,
        reports: reportsEN,
        taxonomy: taxonomyEN,
        scn: scnEN,
      },
      zh: {
        common: commonZH,
        vendors: vendorsZH,
        categories: categoriesZH,
        contacts: contactsZH,
        customers: customersZH,
        products: productsZH,
        orders: ordersZH,
        procurement: procurementZH,
        finance: financeZH,
        occ: occZH,
        shipping: shippingZH,
        claims: claimsZH,
        governance: governanceZH,
        pricing: pricingZH,
        reports: reportsZH,
        taxonomy: taxonomyZH,
        scn: scnZH,
      },
    },
  });

// Make i18n instance globally available for axios interceptor
(window as unknown as { __i18nInstance: typeof i18n }).__i18nInstance = i18n;

// Clear all API caches when language changes
// This ensures fresh data is fetched with the new language
i18n.on('languageChanged', (_lng) => {
  // Clear all ahooks caches for location and other i18n-aware endpoints so fresh
  // localized data is fetched with the new language. Exact-key clear over the
  // tracked keys — the old predicate form was a silent no-op; see cacheKeyRegistry.ts
  clearCacheWhere(
    (key) => key.includes('/locations') || key.includes('lang=') || key.includes('language=')
  );
});

export default i18n;
